// extracted by mini-css-extract-plugin
export default {"component":"IntegerInput_component__WZ3p2"};